"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var javascript_sdk_1 = require("@mdap/javascript-sdk");
var web_vitals_1 = require("web-vitals");
var delay = function (interval) {
    if (interval === void 0) { interval = 500; }
    return new Promise(function (resolve) {
        setTimeout(function () {
            resolve(true);
        }, interval);
    });
};
var isNavigationTiming = function (entry) { return (entry === null || entry === void 0 ? void 0 : entry.entryType) === 'navigation'; };
var supportGetEntriesByType = typeof ((_a = window.performance) === null || _a === void 0 ? void 0 : _a.getEntriesByType) === 'function';
// ordered
var NavitaionTypeMap = ['navigate', 'reload', 'back_forward'];
var PerformancePlugin = /** @class */ (function (_super) {
    __extends(PerformancePlugin, _super);
    function PerformancePlugin(configs) {
        var _this = _super.call(this, configs) || this;
        _this.type = 'navigation';
        _this.webVitalsMetrics = {
            cumulative_layout_shift: -1,
            first_input_delay: -1,
            largest_contentful_paint: -1
        };
        _this.configs = configs;
        return _this;
    }
    PerformancePlugin.prototype.register = function (props) {
        this.trigger = props.trigger;
        this.projectId = props.app_name;
        this.init();
    };
    PerformancePlugin.prototype.init = function () {
        if (!supportGetEntriesByType) {
            return;
        }
        if (!this.isMatch) {
            return;
        }
        this.getWebVitalsMetrics();
    };
    PerformancePlugin.prototype.triggerMetrics = function (forceTrigger) {
        var _a;
        if (forceTrigger === void 0) { forceTrigger = false; }
        return __awaiter(this, void 0, void 0, function () {
            var isFulfilled, performanceNavigationData, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        isFulfilled = Object.values(this.webVitalsMetrics).every(function (v) { return v >= 0; });
                        if (!(isFulfilled || forceTrigger)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getPerformanceNavigationTiming()];
                    case 1:
                        performanceNavigationData = _b.sent();
                        data = __assign(__assign({}, performanceNavigationData), this.webVitalsMetrics);
                        (_a = this.trigger) === null || _a === void 0 ? void 0 : _a.call(this, data);
                        // reset webVitalsMetrics
                        this.webVitalsMetrics = {
                            cumulative_layout_shift: -1,
                            first_input_delay: -1,
                            largest_contentful_paint: -1
                        };
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    PerformancePlugin.prototype.getWebVitalsMetrics = function () {
        var _this = this;
        var isTimeout = false;
        var fillWebVitalsMetrics = function (metric) {
            switch (metric.name) {
                case 'CLS':
                    _this.webVitalsMetrics.cumulative_layout_shift = Math.round(metric.value * 1000);
                    break;
                case 'FID':
                    _this.webVitalsMetrics.first_input_delay = Math.round(metric.value);
                    break;
                case 'LCP':
                    _this.webVitalsMetrics.largest_contentful_paint = Math.round(metric.value);
                    break;
            }
            if (!isTimeout) {
                _this.triggerMetrics();
            }
        };
        web_vitals_1.getCLS(fillWebVitalsMetrics);
        web_vitals_1.getFID(fillWebVitalsMetrics);
        web_vitals_1.getLCP(fillWebVitalsMetrics);
        setTimeout(function () {
            var isFulfilled = Object.values(_this.webVitalsMetrics).every(function (v) { return v >= 0; });
            if (!isFulfilled) {
                _this.triggerMetrics(true);
            }
            isTimeout = true;
        }, 5000);
    };
    Object.defineProperty(PerformancePlugin.prototype, "isMatch", {
        /** 校验当前路径是否需要上报性能 */
        get: function () {
            var _a;
            if (!((_a = this.configs.path) === null || _a === void 0 ? void 0 : _a.length)) {
                return true;
            }
            var currentUrl = window.location.href;
            for (var _i = 0, _b = this.configs.path; _i < _b.length; _i++) {
                var rule = _b[_i];
                if (currentUrl.match(rule)) {
                    return true;
                }
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * fallback - navigation timing
     * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceTiming
     * @returns
     */
    PerformancePlugin.prototype.getNavigationTiming = function () {
        var _a;
        var timing = performance.timing;
        var pageUrl = location.href.slice(0, 512);
        var timeOrigin = timing.navigationStart;
        var relative = function (value) {
            return value ? value - timeOrigin : value;
        };
        return {
            event_timestamp: this.serverNow(timing.navigationStart),
            duration: relative(timing.domComplete),
            page_url: pageUrl,
            navigation_type: (_a = NavitaionTypeMap[performance.navigation.type]) !== null && _a !== void 0 ? _a : 'unknown',
            referer: document.referrer,
            start_time: relative(Math.max(timing.redirectStart, timing.navigationStart)),
            redirect_start: relative(timing.redirectStart),
            redirect_end: relative(timing.redirectEnd),
            redirect_count: performance.navigation.redirectCount,
            fetch_start: relative(timing.fetchStart),
            domain_lookup_start: relative(timing.domainLookupStart),
            secure_connection_start: relative(timing.secureConnectionStart),
            domain_lookup_end: relative(timing.domainLookupEnd),
            connect_start: relative(timing.connectStart),
            connect_end: relative(timing.connectEnd),
            request_start: relative(timing.requestStart),
            response_start: relative(timing.responseStart),
            response_end: relative(timing.responseEnd),
            unload_event_start: relative(timing.unloadEventStart),
            unload_event_end: relative(timing.unloadEventEnd),
            dom_interactive: relative(timing.domInteractive),
            dom_content_loaded_event_start: relative(timing.domContentLoadedEventStart),
            dom_content_loaded_event_end: relative(timing.domContentLoadedEventEnd),
            dom_complete: relative(timing.domComplete),
            load_event_start: relative(timing.loadEventStart),
            load_event_end: relative(timing.loadEventEnd),
            worker_start: -1,
            first_paint_start: -1,
            first_contentful_paint_start: -1
        };
    };
    PerformancePlugin.prototype.getNavigationPerformanceData = function () {
        var _a, _b;
        var entry = performance.getEntriesByType('navigation')[0];
        if (isNavigationTiming(entry)) {
            var timeOrigin = performance.timeOrigin || performance.timing.navigationStart;
            var pageUrl = location.href.slice(0, 512);
            var paintEntries = performance.getEntriesByType('paint');
            var FP = (_a = paintEntries.filter(function (paintEntry) { return paintEntry.name === 'first-paint'; })) === null || _a === void 0 ? void 0 : _a[0];
            var FCP = (_b = paintEntries.filter(function (paintEntry) { return paintEntry.name === 'first-contentful-paint'; })) === null || _b === void 0 ? void 0 : _b[0];
            var data = {
                event_timestamp: this.serverNow(Math.round(timeOrigin)),
                duration: Math.round(Math.max(entry.domComplete - entry.startTime, entry.duration)),
                page_url: pageUrl,
                navigation_type: entry.type,
                referer: document.referrer,
                start_time: Math.round(entry.startTime),
                redirect_count: Math.round(entry.redirectCount),
                redirect_start: Math.round(entry.redirectStart),
                redirect_end: Math.round(entry.redirectEnd),
                fetch_start: Math.round(entry.fetchStart),
                secure_connection_start: Math.round(entry.secureConnectionStart),
                domain_lookup_start: Math.round(entry.domainLookupStart),
                domain_lookup_end: Math.round(entry.domainLookupEnd),
                connect_start: Math.round(entry.connectStart),
                connect_end: Math.round(entry.connectEnd),
                request_start: Math.round(entry.requestStart),
                response_start: Math.round(entry.responseStart),
                response_end: Math.round(entry.responseEnd),
                unload_event_start: Math.round(entry.unloadEventStart),
                unload_event_end: Math.round(entry.unloadEventEnd),
                dom_interactive: Math.round(entry.domInteractive),
                dom_content_loaded_event_start: Math.round(entry.domContentLoadedEventStart),
                dom_content_loaded_event_end: Math.round(entry.domContentLoadedEventEnd),
                dom_complete: Math.round(entry.domComplete),
                load_event_start: Math.round(entry.loadEventStart),
                load_event_end: Math.round(entry.loadEventEnd),
                worker_start: Math.round(entry.workerStart),
                first_paint_start: (FP === null || FP === void 0 ? void 0 : FP.startTime) ? Math.round(FP === null || FP === void 0 ? void 0 : FP.startTime) : -1,
                first_contentful_paint_start: (FCP === null || FCP === void 0 ? void 0 : FCP.startTime) ? Math.round(FCP === null || FCP === void 0 ? void 0 : FCP.startTime) : -1
            };
            return data;
        }
        else {
            // fallback - safari
            var data = this.getNavigationTiming();
            return data;
        }
    };
    PerformancePlugin.prototype.getPerformanceNavigationTiming = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var handler = function () { return __awaiter(_this, void 0, void 0, function () {
                var data, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            /**
                             * load_event_end 事件会在 load 事件执行完之后才能取到有效值，否则为0
                             */
                            return [4 /*yield*/, delay(0)];
                        case 1:
                            /**
                             * load_event_end 事件会在 load 事件执行完之后才能取到有效值，否则为0
                             */
                            _a.sent();
                            data = this.getNavigationPerformanceData();
                            resolve(data);
                            return [3 /*break*/, 3];
                        case 2:
                            error_1 = _a.sent();
                            reject(error_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            if (document.readyState === 'complete') {
                handler();
            }
            else {
                var handleOnload_1 = function () {
                    return handler().finally(function () {
                        window.removeEventListener('load', handleOnload_1);
                    });
                };
                window.addEventListener('load', handleOnload_1);
            }
        });
    };
    // deprecated
    PerformancePlugin.prototype.handlePerformance = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    return PerformancePlugin;
}(javascript_sdk_1.BasePlugin));
exports.default = PerformancePlugin;
